export class Persona {
    constructor(
        personaId = 0,
        tipoPersonaId = null,
        nombre = null,
        paterno = null,
        materno = null,
        adscripcionId = null,
        puesto = null,
        denunciaId = null,
        activo = null,
        adscripcion= null
    ) {
        this.personaId = personaId;
        this.tipoPersonaId = tipoPersonaId;
        this.nombre = nombre;
        this.paterno = paterno;
        this.materno = materno;
        this.adscripcionId = adscripcionId;
        this.puesto = puesto;
        this.denunciaId = denunciaId;
        this.activo = activo;
        this.adscripcion = adscripcion;
    }
    constructorObjeto(personaObject) {
        this.personaId = personaObject.personaId;
        this.tipoPersonaId = personaObject.tipoPersonaId;
        this.nombre = personaObject.nombre;
        this.paterno = personaObject.paterno;
        this.materno = personaObject.materno;
        this.adscripcionId = personaObject.adscripcionId;
        this.puesto = personaObject.puesto;
        this.denunciaId = personaObject.denunciaId;
        this.activo = personaObject.activo;
        this.adscripcion = personaObject.adscripcion;
    }
    cargarDatosParaFormulario(args) {
        if (args.includes('insertar-persona')) {
            this.personaId = null;
            this.activo = true;
            this.puesto = (this.puesto) ? this.puesto : "";
            this.adscripcionId = typeof this.adscripcionId === "string" ? parseInt(this.adscripcionId) : this.adscripcionId;
            this.adscripcionId = this.adscripcionId === -1 ? null : this.adscripcionId;
        }
        if (args.includes('datos-generales')) {
            this.adscripcionId = -1;
          this.tipoPersonaId = 1;
        }
    }
    nombreCompleto() {
        return [this.nombre,this.paterno,this.materno].filter(palabra => palabra).join(" ");
     }
}



// WEBPACK FOOTER //
// ./src/components/SIFA/Comun/Modelos/Persona.js